module.exports = __webpack_public_path__ + "static/img/right-num-row-0.a3b689a5.webp";